import { render, staticRenderFns } from "./DataTableInfiniteScroll.vue?vue&type=template&id=ac06e756"
import script from "./DataTableInfiniteScroll.vue?vue&type=script&lang=js"
export * from "./DataTableInfiniteScroll.vue?vue&type=script&lang=js"
import style0 from "./DataTableInfiniteScroll.vue?vue&type=style&index=0&id=ac06e756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports